








import Vue from "vue";
import Geolocation from "@/services/geolocation";

export default Vue.extend({
  data: () => ({
    isGeolocationEnabled: false,
    city: ""
  }),

  created() {
    this.setGeolocationStatus();
  },

  watch: {
    isGeolocationEnabled() {
      if (this.isGeolocationEnabled) this.goToHome();
    }
  },

  methods: {
    goToHome() {
      this.$router.replace({ name: "Home" });
    },

    async setGeolocationStatus() {
      this.isGeolocationEnabled = await Geolocation.isEnabled();
    },

    getCurrentLocation() {
      Geolocation.get(
        () => {
          this.isGeolocationEnabled = true;
        },
        err => {
          console.warn(`ERROR(${err.code}): ${err.message}`);
        }
      );
    }
  }
});
